import {
  apiActionBuilder,
  apiRequestPayloadBuilder,
  ApiRequestPayloadBuilderOptions,
  ApiSuccessAction,
  HttpMethod,
} from "../api-builder";
import { INotification } from "models/Notification";

export interface PostNotificationsParams {
  title: string;
  description: string;
  eventId: string;
  merchantId: string;
  isTest: boolean;
}

export interface PostNotificationsResponseData {
  notification: INotification;
}

export default apiActionBuilder<
  PostNotificationsParams,
  ApiSuccessAction<PostNotificationsResponseData, PostNotificationsParams>
>(
  "apis/notifications/post",
  (
    params: PostNotificationsParams,
    options?: ApiRequestPayloadBuilderOptions,
  ) => ({
    payload: apiRequestPayloadBuilder(
      {
        path: "/notifications",
        method: HttpMethod.POST,
        body: {
          title: params.title,
          description: params.description,
          eventId: params.eventId,
          merchantId: params.merchantId,
          isTest: params.isTest,
        },
      },
      options,
      params,
    ),
  }),
);
